import { Component, OnInit } from "@angular/core";
import { SiteSEOHelperService } from "src/app/services/siteseoHelper.service";
import { DResult } from "src/app/models/common.models/dresult.model";
import { ActivatedRoute } from "@angular/router";
import { API_ServerAddress } from "src/app/MyAppCommonConfig";
import { BlogGetDetailOutputDTO } from 'src/app/models/contents.models/Blog.models/BlogGetDetailOutputDTO.model';
import { BlogsSiteService } from 'src/app/services/blogsSiteService';

@Component({
  selector: "blogdetails",
  templateUrl: "blogdetails.component.html"
})
export class BlogDetailsComponent implements OnInit {
  ngOnInit(): void {
    this.GetItemDetail();
  }

  APIServerAddress: string = API_ServerAddress;
  id: number;
  itemDetail: BlogGetDetailOutputDTO = new BlogGetDetailOutputDTO();
  ImageAddress: string = "#";

  constructor(
    private route: ActivatedRoute,
    private siteSEOHelperService: SiteSEOHelperService,
    private blogsSiteService: BlogsSiteService
  ) {
    this.id = +this.route.snapshot.paramMap.get("id");
  }

  GetItemDetail() {
    this.blogsSiteService
      .GetById(this.id)
      .subscribe((data: DResult<BlogGetDetailOutputDTO>) => {
        if (data.isSuccess) {
          this.itemDetail = data.result;
          this.ImageAddress =
            this.APIServerAddress + this.itemDetail.imageAddressHighQuality;

          this.siteSEOHelperService.SetPageMetaData(
            this.itemDetail.metaTitle,
            this.itemDetail.metaDescription,
            this.itemDetail.metaKeywords
          );
        }
      });
  }
}
